document.querySelectorAll('.product').forEach(section => {
    const productJSON = section.querySelector(".productJSON")?.textContent;
    const variantJSON = section.querySelector(".activeVariantJSON")?.textContent;
    if (!productJSON || !variantJSON) return;

    const product = JSON.parse(productJSON);
    let activeVariant = JSON.parse(variantJSON);

    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    const trigger = section.querySelector(".sizeGuideTrigger");
    const modalId = trigger?.dataset.modalTarget;
    const modal = modalId ? document.getElementById(modalId) : null;

    if (trigger && modal) {
        const closeBtn = modal.querySelector(".sizeGuideClose");

        trigger.addEventListener("click", () => {
            modal.classList.add("active");
            document.body.style.overflow = "hidden";
        });

        closeBtn?.addEventListener("click", () => {
            modal.classList.remove("active");
            document.body.style.overflow = "";
        });

        modal.addEventListener("click", (e) => {
            if (e.target === modal) {
                modal.classList.remove("active");
                document.body.style.overflow = "";
            }
        });
    }


    /************
     Product Swiper
     ************/
    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        navigation: {
            prevEl: section.querySelector(".productVisualThumbsPrev"),
            nextEl: section.querySelector(".productVisualThumbsNext"),
        },
        breakpoints: {
            0: {
                slidesPerView: 1.6,
                spaceBetween: 10,
            },
            801: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        },
        on: {
            slideChange: function () {
                const thumbs = section.querySelectorAll(".productVisualThumbsSlide");
                thumbs.forEach(el => el.classList.remove("active"));

                const realIndex = this.realIndex % thumbs.length;
                thumbs[realIndex]?.classList.add("active");

                section.querySelectorAll(".productVisualSwiperSlide video").forEach(video => video.pause());
            }
        }
    });


    // Play video on click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(slide => {
        slide.addEventListener("click", () => {
            const video = slide.querySelector("video");
            if (!video) return;
            slide.querySelector(".productVisualSwiperSlidePlay")?.remove();
            video.controls = true;
            video.play();
        });
    });

    // Thumbnail slide click
    section.querySelectorAll(".productVisualThumbsSlide").forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
            productSwiper.slideToLoop(index);
        });
    });

    // Variant change handling
    section.querySelectorAll("input[type=radio], select").forEach(input => {
        input.addEventListener("change", updateProduct);
    });


    /************
     Update Product
     ************/
    async function updateProduct() {
        if (product.variants.length === 1) {
            activeVariant = product.variants[0];
        } else {
            const selectedOptions = Array.from(section.querySelectorAll(".productFormOptionsItem"))
                .map(group => group.querySelector("input:checked")?.value);

            activeVariant = product.variants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptions));
        }

        const atcButton = section.querySelector(".productATCButton");
        const atcText = section.querySelector(".productATCText");
        const atcPrice = section.querySelector(".productATCPrice");

        if (!activeVariant) {
            if (atcButton) atcButton.disabled = true;
            if (atcText) atcText.textContent = "Not Available";
            if (atcPrice) atcPrice.textContent = "";
            return;
        }

        // Update ATC button
        if (atcButton) atcButton.disabled = !activeVariant.available;
        if (atcText) atcText.innerHTML = activeVariant.available ? "Add to Cart –&nbsp;" : "Sold Out";
        if (atcPrice) atcPrice.textContent = activeVariant.available ? price(activeVariant.price) : '';

        // Update Swiper if there's a featured image
        if (!initialLoad && activeVariant.featured_image?.position) {
            productSwiper.slideToLoop(activeVariant.featured_image.position - 1);
        }

        // Price display
        const compareEl = section.querySelector(".productFormSellingOptionHeaderPriceCompare");
        const realEl = section.querySelector(".productFormSellingOptionHeaderPriceReal");

        if (compareEl && realEl) {
            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price);
            } else {
                compareEl.textContent = "";
            }
            realEl.textContent = price(activeVariant.price);
        }

        // Update URL
        const url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    let initialLoad = true;

    updateProduct(); // Run on load
    initialLoad = false;

    /**************
     Add to Cart
     ***************/
    async function addToCart() {
        const atcButton = section.querySelector(".productATCButton");
        atcButton.classList.add("loading");

        const formData = {
            items: [{
                id: activeVariant.id,
                quantity: 1
            }]
        };

        await addProduct(formData);
        atcButton.classList.remove("loading");
        await openCart();
    }

    section.querySelector(".productATCButton")?.addEventListener("click", addToCart);
});
